import React from 'react'
import { Button, Modal } from 'semantic-ui-react';

type Props = {
    header: string,
    children?: React.ReactNode
    open: boolean,
    setOpen: (isOpen: boolean) => void;
}

const MeleeModal = ({ header, open, setOpen, children }: Props) => (
    <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        className='melee-modal'
        style={{ maxWidth: '50em' }}
    >
        <Modal.Content>
            <h2>{header}</h2>
            <div style={{ marginTop: 32 }}>
                {children}
            </div>
            <div className='action'>
                <Button
                    style={{ marginTop: 32 }}
                    basic color='yellow' inverted onClick={() => setOpen(false)}>
                    Done
                </Button>
            </div>
        </Modal.Content>
    </Modal>
)

export default MeleeModal;